import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, handleBackendFormErrors, tailFormItemLayout, unexpectedError } from '../../common_functions';

const Date_Confidence = props => {
  const { section, id } = useParams();
  const [confidence, setconfidence] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id !== 'new') {
        try {
          setLoading(true);
          const { data } = await props.getItem('date_confidence', id);
          setconfidence(data);
          formRef.current.setFieldsValue(data);
        } catch (error) {
          console.error(error);
          unexpectedError(error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    try {
      setLoading(true);
      let newState = { ...confidence, ...values };
      const response = await props.saveItem('date_confidence', newState);
      if (response) {
        notification['success']({
          message: 'Date Confidence saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/date-confidence`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/date-confidence" }, { title: "Date Confidence", href: "/settings/date-confidence" }, { title: id !== 'new' ? `Edit Date Confidence` : 'Add Date Confidence' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Date Confidence: ${id}` : 'Add Date Confidence'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              {id !== 'new' ? (
                <Row gutter={24}>
                  {' '}
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="id" label="ID(System Generated)">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                ''
              )}

              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="date_confidence"
                    label="Date Confidence"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Date confidence is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter date confidence" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="value"
                    label="Value"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Value is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter value" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea rows={5} placeholder="Enter description..." />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/date-confidence')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_date_confidence, !!confidence ? confidence.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default Date_Confidence;
